/*
Router for github.io (SPA)
*/



export default Backbone.Router.extend({
    name: 'main',
    initialize(options) {
        this.options = options;
        // this.bind('route', this._pageView);
        console.log('router is being initialized');
        this.controllers = options.controllers;
    },
    routes: {
        '': 'index',
        'cv': 'cv',
        'map': 'map'
    },
    index() {
        this.controllers.home.index();
    },
    cv() {
        this.controllers.cv.index();
    },
    map() {
        this.controllers.map.index();
    }
});


// WEBPACK FOOTER //
// src/js/router/main.js